






























































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
import { InspectItem } from "@/model/InspectItem";
import { Getter, Action } from "vuex-class";
import {
  Buhin,
  BuhinCategory,
  SubBuhinCategory,
  BuhinDetail
} from "@/model/Buhin";
import requestService from "@/service/requestService";
import * as util from "@/service/util";
import { Work } from "@/model/Work";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { inspectService } from "@/service/inspectService";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { Bunrui } from "@/model/Work";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CarSelectData } from "@/model/CarSelection";
import ReservationDetailState from "@/store/reservation/state";

@Component({
  components: { InputNumber, ConfirmDialog }
})
export default class WorkAndBuhin extends Vue {
  // @Prop({ default: "" })
  // title!: string;
  @Prop({ default: {} })
  data!: any;
  @Prop({ default: true })
  editSeibi!: boolean;
  @Prop({ default: true })
  showTitle!: boolean;
  @Prop({ default: true })
  closeBtn!: boolean;
  @Prop({ default: true })
  isDialog!: boolean;

  @Prop({ default: false })
  editResult!: boolean;

  @Getter("buhin", { namespace: "Buhin" })
  listBuhinData: Buhin[];

  @Getter("katashiki", { namespace: "CarSelection" })
  katashiki: string;

  @Getter("engineKatashiki", { namespace: "CarSelection" })
  engineKatashiki: string;

  @Action("setState", { namespace: "Buhin" })
  saveBuhin: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  currentState: ReservationDetailState;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  /** 2021-12-03 sh #7594 Because it is cached, call it directly. [START] */
  // @Getter("shadaiNo", { namespace: "ReservationDetail" })
  // shadaiNo: string;
  /** 2021-12-03 sh #7594 Because it is cached, call it directly. [END] */

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;

  @Getter("isExist", { namespace: "SeibiIds" })
  isSeibiExist!: (seibiDetailId: number, type: number) => boolean;

  /** 2021-12-01 sh #7587 change check seibiIds. [START] */
  @Getter("isSeibiDetailIdExist", { namespace: "SeibiIds" })
  isSeibiDetailIdExist!: (payload: any) => boolean;
  /** 2021-12-01 sh #7587 change check seibiIds. [END] */

  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: string;

  @Action("add", { namespace: "SeibiIds" })
  addSeibiId: any;

  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;

  listSelectedBuhin: any = [];
  listBuhinActiveSebi: BuhinDetail[] = [];
  listManualBuhin: BuhinDetail[] = [];
  listManualBuhinFiltered: BuhinDetail[] = [];
  listManualBuhinName: string = "手入力";
  activeBuhinCateIndex: number = -1;
  sliderValue: number = 0;
  allowCustomerSelect: boolean = false;
  manualWorkNm: string = "";
  manualBuhinNm: string = "";
  manualKousuu: number | null = null;
  buhinCategory: BuhinCategory[] = [];
  buhinContent: SubBuhinCategory[] = [];
  activeCateBuhins: SubBuhinCategory[] = [];
  selFilter: any[] = [];
  disabledBtnConfirm: boolean = true;
  disabledBtnNoBuhin: boolean = true;
  activeWorkIndex: number = -1;
  isManualWork: boolean = false;
  activeBuhinShubetsuId: number = 0;
  inspectService: inspectService;
  reqService: requestService;
  loadingBuhin: boolean = false;
  isChange: boolean = false;
  isResetSeibi: boolean = false;

  defualtBuhinShubetsuIndex: number = -1;
  defualtBuhinShubetsuCd: string = "";
  defualtBuhinBunruiCdList: string[];
  confirmMsg: string = "";
  showConfirmDialog: boolean = false;
  showConfirmDialog2: boolean = false;
  isBuhin: boolean = false; //Confirm buhin & no buhin
  listBuhinConfirm: any = {};
  activeSeibiId: number | null = 0;
  activeSeibiNm: string = "";
  isKouchinChange: boolean = false;

  $refs!: {
    askAddDialog: ConfirmDialog;
    askDeleteDialog: ConfirmDialog;
  };

  tmpResetWorkIndex: number = -1;
  tmpDeleteWorkIndex: number = -1;
  tmpDeletedBuhin: any = null;
  tmpDeletedManualBuhinBuff: any = [];//削除済みリスト
  tmpDeletedManualBuhinList: any = [];//削除後確定済みリスト

  osusumeBuhinList: any = [];
  showBuhin: boolean = true;
  buhinTankaPlaceHolder: string = "単価(税抜)を入力してください";
  buhinChangeList: any = {};
  workBeforeChange: any = null;
  isSocket: boolean = false;
  isBuhinError: boolean = false;
  workConfirm: any = {};
  firstBuhinCd: any = null;
  nRetryScroll = 0;
  // 2022-01-31 morisako kobac-free add [START]
  freeOfChargeNm: string = '無償対応';
  freeOfChargeBuhinList: any = [];
  isDiscount: boolean = false;
  // 2022-01-31 morisako kobac-free add [END]
  /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [START] */
  loading: boolean = false;
  loadingText: string = MESSAGE.Loading;
  /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [END] */

  created() {
    this.inspectService = new inspectService();
    this.reqService = new requestService();
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
    // if (this.data.seibiList) {
    if (this.data.seibiList && this.data.seibiList.length > 0) {
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
      this.initSeibiDisableSave(this.data.seibiList);
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    } else if (this.data.manualSeibiList && this.data.manualSeibiList.length > 0) {
      this.initSeibiDisableSave(this.data.manualSeibiList);
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    }
    if (this.isDialog) {
      if (this.data.seibiList) {
        if (this.data.workBuhinSelected > 1) {
          this.keepBuhinConfirm(this.data.seibiList);
          this.keepBuhinConfirm(this.data.manualSeibiList);
        }
      } else {
        this.keepBuhinConfirmOsusume(this.data, true);
      }
    }
    if (this.listBuhinData.length == 0) {
      this.loadingBuhin = true;
      this.reqService
        .getPartSelectionBuhin(
          this.uketsukeExtendsId,
          this.katashiki,
          this.engineKatashiki,
          this.seibiMenuCd
        )
        .then(
          (res: any) => {
            if (res && res.length > 0) {
              this.saveBuhin(res);
              this.setBuhinCate();
              /** 2021-09-24 sh #7428 improved initial selecting seibi. [START] */
              this.initialSelectSeibi();
              /** 2021-09-24 sh #7428 improved initial selecting seibi. [END] */
            }
            this.loadingBuhin = false;
          },
          (error: any) => {
            this.loadingBuhin = false;
            this.isBuhinError = true;
            this.hideBuhin();
          }
        );
    } else {
      this.setBuhinCate();
    }
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  inspectResClass() {
    return this.inspectService.inspectResClass(
      this.data.inspectResult,
      this.data.sknInspectType
    );
  }

  setBuhinCate() {
    if (this.listBuhinData.length > 0) {
      const index = this.listBuhinData.length - 1;
      //Add top tap
      this.buhinCategory = util.deepCopy(this.listBuhinData[index].items);
      // this.onSelectBuhinTab(0, false);
      if (Object.keys(this.data).length > 0) {
        if (this.data.seibiList) {
          if (this.data.seibiList.length > 0) {
            let work = util.deepCopy(this.data.seibiList[0]);
            work.buhinList = work.buhinList.filter((e: any) => e.isDelete != 1);
            this.data.seibiList[0].buhinList = work.buhinList;
            this.onSelectWork(work, 0, false);
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
          } else if (this.data.manualSeibiList && this.data.manualSeibiList.length > 0) {
            let work = util.deepCopy(this.data.manualSeibiList[0]);
            this.onSelectWork(work, 0, true, true);
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
          } else {
            this.checkDisabledBtnConfirm();
          }
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
        } else if (this.data.manualSeibiList && this.data.manualSeibiList.length > 0) {
          let work = util.deepCopy(this.data.manualSeibiList[0]);
          this.onSelectWork(work, 0, true, true);
/** 2023-07-24 sh #8429(BQR1109) fix bug. add skn or extreme of work to condition. [START] */
//        } else if (this.editSeibi || !this.data.osusumeId) {
        } else if (this.editSeibi || (!this.data.osusumeId && !this.data.sknInspectSeibiDetailId)) {
/** 2023-07-24 sh #8429(BQR1109) fix bug. add skn or extreme of work to condition. [END] */
          let work = {
            seibiNm: this.data.sknRecommendInspecSeibiNm
            , seibiDetailId: null
            , seibiId: null
            , buhinSelected: this.data.buhinSelected
            , kousuu: this.data.kousuu
            , manualBuhinList: this.data.manualBuhinList
            , buhinList: this.data.osusumeBuhinList
            , sknRecommendInspectCategoryId: null
            , kouchinZn: this.data.kouchinZn
          }
          this.onSelectWork(work, 0, true, true);
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
        } else {
          this.initListSelectedBuhin(this.data);
          this.selectBuhinShubetsu(
            this.data.buhinShubetsuCd,
            this.data.buhinBunruiList
          );
        }
      } else {
        setTimeout(() => {
          this.onkeepBuhinMD15();
        }, 2000);
      }
    }
  }

  filterActive(cd: string) {
    let isHas: number = this.selFilter.findIndex(data => data == cd);
    return isHas != -1 ? true : false;
  }

  checkDisabledBtnConfirm(work?: Work) {
    let disabledBtnConfirm = false;
    let disabledBtnNoBuhin = false;
    if (work && work.buhinList) {
      const manualBuhinList = work.manualBuhinList.filter(
        (e: BuhinDetail) => e.quantity > 0
      );
      if (work.disabledSave) {
        disabledBtnConfirm = true;
        disabledBtnNoBuhin = true;
      } else if (
        work.buhinList.length > 0 ||
        manualBuhinList.length > 0 // ||
        // (work.osusumeBuhinList != null && work.osusumeBuhinList.length > 0)
      ) {
        /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [START] */
        // disabledBtnConfirm = false;
        if (work.isExtreme && work.isExtreme > 0){
          const extremBuhinselectedList = this.listSelectedBuhin.filter(
            (e: any) => e.quantity > 0
          );
          if (extremBuhinselectedList && extremBuhinselectedList.length > 0 || manualBuhinList.length > 0) {
            disabledBtnConfirm = false;
          } else {
            disabledBtnConfirm = true;
          }
        } else {
          disabledBtnConfirm = false;
        }
        /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [END] */
      } else if (work.osusumeBuhinList != null && work.osusumeBuhinList.length > 0) {
        const osusumeBuhinList = work.osusumeBuhinList
          .filter((b: any) => b.isDelete != 1 && (b.isSelected || b.buhinId))
          .map((b: any) => +b.buhinOsusumeId);
        if (osusumeBuhinList && osusumeBuhinList.length > 0) {
          disabledBtnConfirm = false;
        } else {
          disabledBtnConfirm = true;
        }
      } else {
        disabledBtnConfirm = true;
      }
      this.$set(this, "disabledBtnNoBuhin", disabledBtnNoBuhin);
      this.$set(this, "disabledBtnConfirm", disabledBtnConfirm);
    } else {
      if (this.data.seibiList && this.data.manualSeibiList) {
        if (
          this.data.seibiList.length == 0 &&
          this.data.manualSeibiList.length == 0
        ) {
          disabledBtnConfirm = true;
          disabledBtnNoBuhin = true;
        } else if (
          !this.isManualWork &&
          this.data.seibiList.length > 0 &&
          this.data.seibiList[this.activeWorkIndex].disabledSave
        ) {
          disabledBtnConfirm = true;
          disabledBtnNoBuhin = true;
        } else {
          this.checkListBuhinSelected();
        }
      } else {
        this.checkListBuhinSelected();
      }
    }

    this.$set(this, "disabledBtnNoBuhin", disabledBtnNoBuhin);
    if (disabledBtnConfirm) {
      this.$set(this, "disabledBtnConfirm", disabledBtnConfirm);
    }
  }

  onNoSeibi() {
    this.$set(this, "listSelectedBuhin", []);
    this.$set(this, "listManualBuhin", []);
    this.filterManualBuhin();
    this.mapBuhin();
    this.$set(this, "disabledBtnConfirm", true);
    this.$set(this, "disabledBtnNoBuhin", true);
    this.$set(this, "osusumeBuhinList", []);
    this.$set(this, "activeCateBuhins", []);
    this.$set(this, "buhinContent", []);
    this.$set(this, "activeBuhinShubetsuId", 0);
    this.$set(this, "activeBuhinCateIndex", -1);
  }

  checkListBuhinSelected() {
    if (this.listSelectedBuhin.length > 0) {
      this.disabledBtnConfirm = this.listSelectedBuhin.every(
        (buhin: any) => buhin.quantity == 0
      );
    } else if (
      this.listManualBuhin.filter((e: BuhinDetail) => e.quantity > 0).length > 0
    ) {
      this.disabledBtnConfirm = false;
      // this.disabledBtnNoBuhin = false;
    } else {
      this.disabledBtnConfirm = true;
    }
  }

  removeWork(e: any, index: number) {
    e.stopPropagation();
    this.tmpDeleteWorkIndex = index;
    this.$refs.askDeleteDialog.onOpen();
  }

  resetWork() {
    this.isResetSeibi = true;
    this.listSelectedBuhin = [];
    this.listManualBuhin = [];
    this.listManualBuhinFiltered = [];
    this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.Initial);
    this.disabledBtnConfirm = true;
  }

  resetRecommendWork() {
    this.isResetSeibi = true;
    this.listSelectedBuhin = [];
    this.listManualBuhin = [];
    this.listManualBuhinFiltered = [];
    this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.delete);
    this.disabledBtnConfirm = true;
  }

  showConfirmResetWork(e: any, workIndex: number) {
    e.stopPropagation();
    this.activeWorkIndex = workIndex;
    this.tmpResetWorkIndex = workIndex;
    this.$refs.askDeleteDialog.onOpen();
  }

  addWork() {
    if (this.manualWorkNm) {
      const work = {
        seibiNm: this.manualWorkNm,
        seibiDetailId: null,
        seibiId: null,
        buhinSelected: 0,
        kousuu: this.manualKousuu || 0,
        manualBuhinList: [],
        buhinList: [],
        editMode: false
        , sknRecommendInspectCategoryId: null
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
        , kouchinZn: 0
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
      };
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
      // this.data.manualSeibiList.push(work);
      // this.manualWorkNm = "";
      // this.manualKousuu = null;
      // this.scrollTobottom("list-work");
      // const index = this.data.manualSeibiList.length - 1;
      // this.onSelectWork(work, index, true, true);
      let inspectDescription = this.setInspectDescription(work);
      this.reqService.getManualKouchin(inspectDescription).then((res: any) => {
        work.kouchinZn = res.body;
        if (!this.data.manualSeibiList) {
          let list = [];
          list.push(work);
          this.data.manualSeibiList = list;
        } else {
          this.data.manualSeibiList.push(work);
        }
        this.manualWorkNm = "";
        this.manualKousuu = null;
        this.scrollTobottom("list-work");
        const index = this.data.manualSeibiList.length - 1;
        /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [START] */
        this.$set(this, "loading", true);
        /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [END] */
        this.onSelectWork(work, index, true, true);
        /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [START] */
        setTimeout(() => {
          this.$set(this, "loading", false);
          this.onConfirmNoBuhin();
        }, 1000);
        /** 2023-07-04 sh #8392(BQR1134) confirm no buhin after add manual work. [END] */
      }, (err: any) => {
        this.data.manualSeibiList.push(work);
        this.manualWorkNm = "";
        this.manualKousuu = null;
        this.scrollTobottom("list-work");
        const index = this.data.manualSeibiList.length - 1;
        this.$set(this, "loading", true);
        this.onSelectWork(work, index, true, true);
        setTimeout(() => {
          this.$set(this, "loading", false);
          this.onConfirmNoBuhin();
        }, 1000);
      });
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
    }
  }

  addBuhin() {
    let buhinShubetsuId = this.activeBuhinShubetsuId;
    const buhin = {
      buhinCd: null,
      buhinId: null,
      buhinNm: this.manualBuhinNm,
      quantity: 1,
      buhinShubetsuId,
      buhinPriceZn: 0,
      buhinPriceZk: 0,
      kingakuZn: 0,
      kingakuZk: 0
      , isDelete: 0
    };
    this.listManualBuhin.push(buhin);
    this.listManualBuhinFiltered.push(buhin);
    this.disabledBtnConfirm = false;
    this.manualBuhinNm = "";
    this.scrollTobottom("list-buhin");
    if (this.activeWorkIndex > -1) {
      let work: any;
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
      // if (this.isManualWork) {
      //   work = this.data.manualSeibiList[this.activeWorkIndex];
      // } else {
      //   work = this.data.seibiList[this.activeWorkIndex];
      // }
      if (this.isManualWork && this.editSeibi) {
        work = this.data.manualSeibiList[this.activeWorkIndex];
      } else if (this.data.seibiList && this.data.seibiList.length > 0) {
        work = this.data.seibiList[this.activeWorkIndex];
      } else {
        work = this.data;
      }
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
      work.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      this.isChange = true;
    }
    this.listSelectedBuhin.push(buhin);
  }

  onClickAddManualBuhin() {
    if (!this.disabledBtnNoBuhin) {
      if (this.manualBuhinNm) {
        const found = this.listManualBuhin.find(
          e => e.buhinNm == this.manualBuhinNm
        );
        if (found) {
          this.$refs.askAddDialog.onOpen();
        } else {
          this.addBuhin();
        }
      }
    }
  }

  onConfirmAddManualBuhin() {
    this.addBuhin();
  }

  removeBuhin(e: any, buhin: BuhinDetail) {
    e.stopPropagation();
    if (!this.disabledBtnNoBuhin) {
      this.tmpDeletedBuhin = buhin;
      this.$refs.askDeleteDialog.onOpen();
      const index = this.listManualBuhin.findIndex(
        e => e.buhinNm == buhin.buhinNm
      );
    }
  }
  scrollTobottom(id: string) {
    setTimeout(() => {
      let list = document.getElementById(id);
      if (list) {
        list.scrollTo(0, list.scrollHeight);
        list = null;
      }
    }, 50);
  }

  onSelectBuhinTab(index: number) {
    if (index != this.activeBuhinCateIndex) {
      this.activeBuhinCateIndex = index;
      this.activeBuhinShubetsuId =
        this.buhinCategory[this.activeBuhinCateIndex].buhinShubetsuId || 0;
      let buhinContent = util.deepCopy(this.buhinCategory[index].items);
      // 2022-01-31 morisako kobac-free add [START]
/* 2022-04-11 sh #7815(BQR062) buhin name does not display. [START] */
/**
//      buhinContent = buhinContent.map((element: any) => {
//        let items = element.items.map((elm: any) => {
//          let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
//          if (b.length > 0) {
//            return { ...element, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
//          } else {
//            return { ...element, isDiscount: 0 };
//          }
//        });
//        return { ...element, items: items };
//      });
*/
      buhinContent = buhinContent.map((element: any) => {
        let items = element.items.map((elm: any) => {
          let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
          if (b.length > 0) {
            return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
          } else {
            return { ...elm, isDiscount: 0 };
          }
        });
        return { ...element, items: items };
      });
/* 2022-04-11 sh #7815(BQR062) buhin name does not display. [END] */
      // 2022-01-31 morisako kobac-free add [END]
      const activeCateBuhins = util.deepCopy(buhinContent);
      this.$set(this, "activeCateBuhins", buhinContent);
      this.$set(this, "buhinContent", buhinContent);
      this.filterManualBuhin();
      this.mapBuhin();
    }
  }

  onFilter(cd: string) {
    //filter on head content
    if (cd != "") {
      let isHas: number = this.selFilter.findIndex(data => data == cd);
      if (isHas == -1) {
        this.selFilter.push(cd);
      } else {
        this.selFilter = this.selFilter.filter(sel => sel != cd);
      }
    }
    if (this.selFilter.length != 0) {
      let buhinContent: any = [];
      this.selFilter = this.selFilter.sort();
      this.selFilter.forEach(element => {
        const tempData: any = this.buhinCategory[this.activeBuhinCateIndex].items.filter(
          data => data.buhinBunruiCd == element
        );
        if (tempData.length > 0) {
          let tempItems = tempData[0].items.map((elm: any) => {
            let fil = this.listSelectedBuhin.filter((bhn: any) => bhn.buhinCd == elm.buhinCd);
            if (fil.length > 0) {
              // 2022-01-31 morisako kobac-free mod [START]
              // return { ...elm, buhinPriceZk: fil[0].buhinPriceZk, buhinPriceZn: fil[0].buhinPriceZn, quantity: fil[0].quantity };
              return { ...elm, buhinPriceZk: fil[0].buhinPriceZk, buhinPriceZn: fil[0].buhinPriceZn, quantity: fil[0].quantity, isDiscount: fil[0].isDiscount };
              // 2022-01-31 morisako kobac-free mod [END]
            } else {
              return { ...elm };
            }
          });
          buhinContent.push({ ...tempData[0], items: tempItems });
        }
      });
      // 2022-01-31 morisako kobac-free add [START]
      buhinContent = buhinContent.map((element: any) => {
        let items = element.items.map((elm: any) => {
          let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
          if (b.length > 0) {
            return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
          } else {
            return { ...elm, isDiscount: 0 };
          }
        });
        return { ...element, items: items };
      });
      // 2022-01-31 morisako kobac-free add [END]
      this.$set(this, "buhinContent", buhinContent);
    } else {
      let data = this.activeCateBuhins.map((bunrui: any) => {
        let items = bunrui.items.map((item: any) => {
            let fil = this.listSelectedBuhin.filter((bhn: any) => bhn.buhinCd == item.buhinCd);
            if (fil.length > 0) {
              return { ...item, buhinPriceZk: fil[0].buhinPriceZk, buhinPriceZn: fil[0].buhinPriceZn, quantity: fil[0].quantity };
            } else {
              return { ...item };
            }
        });
        return { ...bunrui, items: items };
      });
      // 2022-01-31 morisako kobac-free add [START]
      data = data.map((element: any) => {
        let items = element.items.map((elm: any) => {
          let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
          if (b.length > 0) {
            return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
          } else {
            return { ...elm, isDiscount: 0 };
          }
        });
        return { ...element, items: items };
      });
      // 2022-01-31 morisako kobac-free add [END]
      this.$set(this, "buhinContent", data);
    }
  }

  findBuhinIndex(item: any) {
    return this.listSelectedBuhin.findIndex(
      (buhin: any) =>
        (buhin.buhinCd == item.buhinCd ||
          buhin.buhinOsusumeId == item.buhinOsusumeId) &&
        buhin.buhinNm == item.buhinNm
    );
  }

  /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [START] */
  findManualIndex(item: any) {
    return this.listSelectedBuhin.findIndex(
      (buhin: any) => buhin.buhinNm == item.buhinNm
    );
  }
  /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [END] */

  onPlus(item: any, i: number, j: number) {
    if (!this.disabledBtnNoBuhin) {
      if (Number(item.quantity) < 9) {
        let step = Number(item.quantityStep) || 1;
        if (item.quantity == 0 && item.defaultQuantity) {
          item.quantity = item.defaultQuantity;
        } else {
          item.quantity = Number((+item.quantity + step).toFixed(1));
        }
        if (i > -1) {
          this.buhinContent[i].items[j].quantity = item.quantity;
          const itemIndex = this.findBuhinIndex(item);
          if (itemIndex == -1) {
            this.listSelectedBuhin.push(item);
          } else {
            this.listSelectedBuhin[itemIndex].quantity = item.quantity;
          }
        }
        this.checkDisabledBtnConfirm();
      }
    }
  }

  onMinus(item: any, i: number, j: number) {
    if (!this.disabledBtnNoBuhin) {
      if (Number(item.quantity) > 0) {
        let step = Number(item.quantityStep) || 1;
        item.quantity = Number((item.quantity - step).toFixed(1));
        if (i > -1) {
          this.buhinContent[i].items[j].quantity = item.quantity;
          const itemIndex = this.findBuhinIndex(item);
          if (itemIndex > -1) {
            if (item.quantity == 0) {
              this.listSelectedBuhin.splice(itemIndex, 1);
              this.checkDisabledBtnConfirm();
            } else {
              this.listSelectedBuhin[itemIndex].quantity = item.quantity;
            }
          }
        /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [START] */
        // }
        } else {
          /** 手入力の場合 */
          const manualIndex = this.findManualIndex(item);
          if (manualIndex > -1) {
            if (item.quantity == 0) {
              this.listSelectedBuhin.splice(manualIndex, 1);
            }
          }
        }
        /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [END] */
        this.checkDisabledBtnConfirm();
      }
    }
  }

  reInitBuhin(data: any) {
    /** 2021-07-09 sh #7273 it does not work, if deleted. [START] */
    this.resetBuhin();
    /** 2021-07-09 sh #7273 it does not work, if deleted. [END] */
    let isMd8 = false;
    const work = this.getWork(data);
    if (work.seibiDetailId) {
      this.activeSeibiId = work.seibiDetailId;
      if (
        work.sknInspectType == INSPECT_TYPE.RECOMMEND ||
        work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
      ) {
        isMd8 = true;
      }
    }
    setTimeout(() => {
      if (isMd8) {
        this.onkeepBuhinMD15(data);
      } else {
        this.keepBuhinConfirmOsusume(work);
      }
      this.onSelectWork(work, this.activeWorkIndex, this.isManualWork, true);
      this.$forceUpdate();
    }, 300);
  }

  initListSelectedBuhin(work: any) {
    if (!this.isDialog) {
      if (
        work.sknInspectType == INSPECT_TYPE.RECOMMEND ||
        work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
      ) {
        this.keepBuhinConfirmOsusume(work);
      } else {
        this.keepBuhinConfirm([work]);
      }
    } else {
      this.onkeepBuhinMD15();
    }
    let listCd: any = [];
    let listDupIndex: number[] = [];
    if (work && work.buhinList) {
      work.buhinList.forEach((buhin: any, index: number) => {
        if (listCd.indexOf(buhin.buhinCd) == -1) {
          listCd.push(buhin.buhinCd);
        } else {
          listDupIndex.push(index);
        }
      });
    }
    if (listDupIndex.length > 0) {
      for (let i = listDupIndex.length - 1; i >= 0; i--) {
        work.buhinList.splice(listDupIndex[i], 1);
      }
    }
    let buhinList: any = [];
    if (work && work.buhinList) buhinList = util.deepCopy(work.buhinList);
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [START] */
    // buhinList = buhinList.filter((b: any) => b.isDelete != 1 && b.quantity > 0);
    buhinList = buhinList.filter((b: any) => b.isDelete != 1 && (b.quantity > 0 || (b.isExtreme === 1 || b.isExtreme === 2)));
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [END] */
    if (work.sknInspectType == INSPECT_TYPE.RECOMMEND || work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
        let osusumeBuhinList = work.osusumeBuhinList.filter((b: any) => b.isDelete != 1 && b.id != null);
        if (osusumeBuhinList && osusumeBuhinList.length > 0) {
          buhinList = [...buhinList, ...osusumeBuhinList];
        } else {
          if (work.osusumeBuhinList.length == 1) {
            work.osusumeBuhinList[0].isSelected = true;
          }
        }
      }
    }
    // 2022-01-31 morisako kobac-free add [START]
    if (work && work.freeOfChargeBuhinList && work.freeOfChargeBuhinList.length > 0) {
      let freeOfChargeBuhinList = work.freeOfChargeBuhinList.filter((b: any) => b != null);
      this.$set(this, "freeOfChargeBuhinList", freeOfChargeBuhinList);
    } else {
      this.$set(this, "freeOfChargeBuhinList", []);
    }
    // 2022-01-31 morisako kobac-free add [END]
    const manualBuhinList = work.manualBuhinList ? work.manualBuhinList: [];
    // const buhinListSelected = buhinList.filter(
    //   (e: BuhinDetail) => e.quantity > 0
    // );
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [START] */
    // const buhinListSelected = buhinList;
    const buhinListSelected = work.isExtreme == 0 ? buhinList : buhinList.filter((e: BuhinDetail) => e.quantity > 0);
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [END] */
    /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [START] */
    let manualBuhinListSelected = work.manualBuhinList
      .filter((b: any) => b.isDelete != 1 && b.quantity > 0);
    if (manualBuhinListSelected && manualBuhinListSelected.length > 0) {
      manualBuhinListSelected.forEach((element: any) => {
        /** 2023-01-31 sh #8018(BQR1031) add manual buhin check. [START] */
        // buhinListSelected.push(element);
        buhinListSelected.push({...element, isManual: true});
        /** 2023-01-31 sh #8018(BQR1031) add manual buhin check. [END] */
      });
    }
    /** 2022-07-26 sh #8002(BQR1021) add checking quantiry of manual buhin. [END] */

    this.$set(this, "listSelectedBuhin", buhinListSelected);
    this.$set(this, "listManualBuhin", manualBuhinList);
    this.$set(this, "listBuhinActiveSebi", buhinList);
    this.filterManualBuhin();
    this.checkDisabledBtnConfirm(work);
    // this.mapBuhin();
  }

  onSelectWork(
    work: Work,
    index: number,
    isManual: boolean,
    forceSelect: boolean = false
  ) {
    this.$set(this, "osusumeBuhinList", []);
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    if (!(index == this.activeWorkIndex && this.isManualWork == isManual && !work.manualBuhinList)) {
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    /** 2021-07-09 sh #7273 it does not work, if deleted. [START] */
    this.$set(this, "listManualBuhinFiltered", []);
      /** 2021-07-09 sh #7273 it does not work, if deleted. [END] */
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    this.firstBuhinCd = null;
    this.nRetryScroll = 0;
    if (work == null) {
      return;
    }
    /** #8299(BQR1105) It does not work discount when buhin count is 1. [START] */
    this.isDiscount = false; // reset for init.
    /** #8299(BQR1105) It does not work discount when buhin count is 1. [END] */
    if (this.listBuhinData.length == 0) {
      return;
    }
    if (
      forceSelect ||
      !(index == this.activeWorkIndex && this.isManualWork == isManual)
    ) {
      if (!this.isDialog) {
        this.workBeforeChange = util.deepCopy(work);
        this.buhinChangeList = {};
      }
      this.isManualWork = isManual;
      this.activeWorkIndex = index;
      this.activeSeibiId = work.seibiDetailId;
      if (isManual) {
        this.activeSeibiNm = work.seibiNm;
      }
      this.initListSelectedBuhin(work);
      let buhinShubetsuCd = "";
      let isActiveExt = false;
      if (work.buhinShubetsuCd) {
        buhinShubetsuCd = work.buhinShubetsuCd;
      } else if (
        work.buhinList && work.buhinList.length > 0 &&
        work.buhinList[0].buhinShubetsuId
      ) {
        buhinShubetsuCd = this.findBuhinShubetsuCd(
          work.buhinList[0].buhinShubetsuId
        );
        if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
          this.osusumeBuhinList = work.osusumeBuhinList;
          this.onSelectOsusumeTab();
          return;
        } else if (work.sknRecommendInspectCategoryId) {
          this.onSelectOsusumeTab();
          return;
        }
      } else {
        if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
          this.osusumeBuhinList = work.osusumeBuhinList;
          this.onSelectOsusumeTab();
          return;
        } else if (work.sknRecommendInspectCategoryId) {
          this.onSelectOsusumeTab();
          return;
        }
        const listExtreme = this.getExtremBuhinMaster();
        if (listExtreme.length > 0) {
          this.onSelectExtremeTab();
          isActiveExt = true;
        } else {
          if (
            !this.isDialog &&
            work.buhinList.length > 0 &&
            work.buhinList[0].buhinCd
          ) {
            for (let i = 0; i < this.buhinCategory.length; i++) {
              let shubetsu = this.buhinCategory[i];
              for (let j = 0; j < shubetsu.items.length - 1; j++) {
                let bunrui = shubetsu.items[j];
                for (let k = 0; k < bunrui.items.length - 1; k++) {
                  let buhin = bunrui.items[k];
                  if (buhin.buhinCd == work.buhinList[0].buhinCd) {
                    buhinShubetsuCd = shubetsu.buhinShubetsuCd || "";
                    break;
                  }
                }
              }
            }
          } else if (
            work.buhinList.length == 0 &&
            work.manualBuhinList.length > 0
          ) {
            const buhinShubetsuId = work.manualBuhinList[0].buhinShubetsuId;
            if (buhinShubetsuId != null) {
              buhinShubetsuCd = this.findBuhinShubetsuCd(buhinShubetsuId);
            }
          }
        }
      }
      if (work.osusumeBuhinList == null || work.osusumeBuhinList.length == 0) {
        this.osusumeBuhinList = [];
      }
      if (!isActiveExt) {
        this.selectBuhinShubetsu(buhinShubetsuCd, work.buhinBunruiList);
      }
      // 2022-01-31 morisako kobac-free add [START]
      if (work.isDiscount) {
        this.isDiscount = true;
      } else {
        this.isDiscount = false;
      }
      // 2022-01-31 morisako kobac-free add [END]
      this.scrollToBuhin();
    }
  }

  findBuhinShubetsuCd(buhinShubetsuId: any) {
    let buhinShubetsuCd = "";
    let _cate = this.buhinCategory.find(
      cate => cate.buhinShubetsuId == buhinShubetsuId
    );
    if (_cate && _cate.buhinShubetsuCd) {
      buhinShubetsuCd = _cate.buhinShubetsuCd;
    }
    return buhinShubetsuCd;
  }

  selectBuhinShubetsu(buhinShubetsuCd: string, buhinBunruiList: any) {
    if (this.listBuhinData.length > 0) {
      if (buhinShubetsuCd) {
        this.defualtBuhinShubetsuCd = buhinShubetsuCd;
        const shubetsuIndex = this.buhinCategory.findIndex(
          cate => cate.buhinShubetsuCd == this.defualtBuhinShubetsuCd
        );
        if (buhinBunruiList && buhinBunruiList.length > 0) {
          this.defualtBuhinBunruiCdList = buhinBunruiList.map(
            (bunrui: Bunrui) => bunrui.buhinBunruiCd
          );
        } else {
          this.defualtBuhinBunruiCdList = [];
        }
        if (this.activeBuhinCateIndex != shubetsuIndex) {
          this.defualtBuhinShubetsuIndex = shubetsuIndex;
          this.onSelectBuhinTab(shubetsuIndex);
        } else {
          let buhinContent = util.deepCopy(
            this.buhinCategory[this.activeBuhinCateIndex].items
          );
          // 2022-01-31 morisako kobac-free add [START]
          buhinContent = buhinContent.map((element: any) => {
            let items = element.items.map((elm: any) => {
              let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
              if (b.length > 0) {
                return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
              } else {
                return { ...elm, isDiscount: 0 };
              }
            });
            return { ...element, items: items };
          });
          // 2022-01-31 morisako kobac-free add [END]
          this.$set(this, "activeCateBuhins", buhinContent);
          this.mapBuhin();
        }
      } else if (
        this.data.osusumeBuhinList &&
        this.data.osusumeBuhinList.length > 0
      ) {
        this.osusumeBuhinList = this.data.osusumeBuhinList;
        this.onSelectOsusumeTab();
      } else if (this.data.isExtreme) {
        this.onSelectExtremeTab();
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
      } else if (this.isManualWork) {
        this.onSelectBuhinTab(6);
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
      } else {
        // this.onSelectBuhinTab(0);
        this.activeBuhinCateIndex = -1;
        this.defualtBuhinShubetsuIndex = -1;
        this.selFilter = [];
        this.buhinContent = [];
        this.activeCateBuhins = [];
      }
    }
  }

  showMsgConfirm() {
    this.$message({
      message: this.isBuhin ? "部品確定しました" : "部品なしで確定しました",
      type: "info",
      duration: 700,
      customClass: "msg-center shadow",
      showClose: true
    });
    setTimeout(() => {
      const btnClose = document.getElementById("btn-close-workbuhin");
      if (btnClose) {
        btnClose.focus();
      }
    }, 0);
  }

  checkIsDone() {
    let work: any = this.getWork();
    let isDone = false;
    if (work.buhinSelected === STATUS_SELECT_WORK_BUHIN.Done) {
      isDone = true;
    }
    return isDone;
  }

  checkBuhinChange(work: any) {
    if (JSON.stringify(this.workConfirm) == JSON.stringify(work)) {
      return true;
    }
    return false;
  }

  onConfirm() {
    this.isBuhin = true;
    // this.confirmMsg = "部品確定しました";
    // this.showConfirmDialog = true;
    this.isResetSeibi = false;
    const doEmit = this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.Done);
    if (doEmit && this.isDialog) {
      //ダイアログ：配列に保存、即終了 -> 完了メッセージを出す
      //ダイアログではない：保存Api実行、時間がかかる
      this.showMsgConfirm();
    }
    this.isKouchinChange = false;
  }

  onConfirmNoBuhin() {
    this.isBuhin = false;
    this.isResetSeibi = false;
    this.buhinContent.forEach((bunrui: any) => {
      bunrui.items.forEach((buhin: any) => {
        this.$set(buhin, "quantity", 0);
      });
    });
    this.listSelectedBuhin = [];
    this.listManualBuhin = this.listManualBuhin.map((b: BuhinDetail) => {
      return { ...b, quantity: 0 };
    });
    this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.Done);
    this.disabledBtnConfirm = true;
    if (this.isDialog) {
      //ダイアログ：配列に保存、即終了 -> 完了メッセージを出す
      //ダイアログではない：保存Api実行、時間がかかる
      this.showMsgConfirm();
      this.isKouchinChange = false;
      //削除確定リストの初期化
      this.tmpDeletedManualBuhinList = [];
    }else{
      this.isKouchinChange = false;
    }
  }

  // onSubmit() {
  //   if (this.isBuhin) {
  //     this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.Done);
  //   } else {
  //     this.listSelectedBuhin = [];
  //     this.listManualBuhin = this.listManualBuhin.map((b: BuhinDetail) => {
  //       return { ...b, quantity: 0 };
  //     });
  //     this.setBuhinToWork(STATUS_SELECT_WORK_BUHIN.Done);
  //     this.disabledBtnConfirm = true;
  //   }
  //   this.showConfirmDialog = false;
  // }

  setBuhinToWork(status: number) {
    this.isChange = true;
    let work;
    if (this.data.seibiList) {
      work = this.data.seibiList[this.activeWorkIndex];
      if (this.isManualWork) {
        work = this.data.manualSeibiList[this.activeWorkIndex];
      }
    } else {
      work = this.data;
    }
    const type = this.data.sknInspectType;
    if (type <= 1) {
      const payload = { ids: [work.seibiDetailId], type };
      if ((status == STATUS_SELECT_WORK_BUHIN.Initial || status == STATUS_SELECT_WORK_BUHIN.delete) && work.buhinSelected) {
        this.isSocket = true;
        this.removeSeibiId(payload);
      } else {
        this.addSeibiId(payload);
      }
    }
    let buhinList: BuhinDetail[] = [];
    let buhinDupList: any = [];
    if (
      /** 2021-08-27 sh #7371 add null check. [START] */
      // (work.buhinList.length > 0 || work.osusumeBuhinList.length > 0) &&
      ((work.buhinList && work.buhinList.length > 0) || (work.osusumeBhinList && work.osusumeBuhinList.length > 0)) &&
      /** 2021-08-27 sh #7371 add null check. [END] */
      this.listSelectedBuhin.length > 0) {
      work.buhinList.forEach((buhin: BuhinDetail) => {
        let foundBuhin: any = this.listSelectedBuhin.find(
          (item: any) => item.buhinCd == buhin.buhinCd
        );
        if (foundBuhin != null) {
          if (buhin.buhinCd) {
            buhinDupList.push(+buhin.buhinCd);
          }
          buhin.isDelete = 0;
          buhin.quantity = foundBuhin.quantity;
          buhin.buhinPriceZn = foundBuhin.buhinPriceZn;
        } else {
          buhin.isDelete = 1;
        }
      });
      let buhinFilterList = this.listSelectedBuhin.filter(
        (buhin: any) =>
          buhin.buhinCd && buhinDupList.indexOf(+buhin.buhinCd) == -1
      );
      buhinFilterList = this.addBuhinIsDelete(buhinFilterList);
      buhinList = [...buhinFilterList, ...work.buhinList];
      /** 2021-08-27 sh #7370 fix script error. [START] */
      if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
        work.osusumeBuhinList.forEach((buhin: BuhinDetail) => {
          let foundBuhin: any = this.listSelectedBuhin.find(
            (item: any) => item.buhinOsusumeId == buhin.buhinOsusumeId
          );
          if (foundBuhin != null) {
            buhinList.push(buhin);
          } else {
            buhin.isDelete = 1;
          }
        });
      }
      /** 2021-08-27 sh #7370 fix script error. [END] */
    } else if (this.listSelectedBuhin.length > 0) {
      // add only
      let buhinFilterList = this.listSelectedBuhin.filter(
        /** 2023-01-31 sh #8018(BQR1031) add manual buhin check. [START] */
        // (buhin: any) => buhin.buhinCd != null
        (buhin: any) => {
          if (buhin.buhinCd != null && (!buhin.hasOwnProperty("isManual") || (buhin.hasOwnProperty("isManual") && !buhin.isManual))) {
            delete buhin.isManual;
            return buhin;
          }
        }
        /** 2023-01-31 sh #8018(BQR1031) add manual buhin check. [END] */

      );
      if (buhinFilterList) buhinList = this.addBuhinIsDelete(buhinFilterList);
    } else if (
      work.buhinList.length > 0 &&
      this.listSelectedBuhin.length == 0
    ) {
      //delete only
      buhinList = work.buhinList
        .filter((b: BuhinDetail) => b.id)
        .map((buhin: BuhinDetail) => {
          return { ...buhin, isDelete: 1 };
        });
    }
    if (buhinList.length > 0) {
      buhinList = buhinList.filter((b: BuhinDetail) => b.isDelete != 1 || b.id);
      buhinList = buhinList.map((e: BuhinDetail) => {
        const buhin = util.deepCopy(e);
        if (buhin.hasOwnProperty("defaultQuantity")) {
          delete buhin.defaultQuantity;
        }
        /** 2022-08-04 sh #8016(BQR1030) set shubetsuId to 0 if isExtreme is 1. [START] */
        // return { ...buhin, buhinShubetsuId: this.activeBuhinShubetsuId };
        const buhinShubetsuId = buhin.isExtreme == 1 ? 0 : this.activeBuhinShubetsuId;
        return { ...buhin, buhinShubetsuId: buhinShubetsuId };
        /** 2022-08-04 sh #8016(BQR1030) set shubetsuId to 0 if isExtreme is 1. [END] */
      });
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
    // if (work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
    if (work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL && work.osusumeId) {
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
      let osusume = buhinList.filter((b: any) => b.buhinOsusumeId != null);
      const arrOsusumeId = osusume.map((e: any) => e.buhinOsusumeId);
      const buhin = buhinList.filter(
        (b: any) =>
          !b.hasOwnProperty("buhinOsusumeId") || b.buhinOsusumeId == null
      );
      work.buhinList = buhin;
      if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
      const osusumeDelete = work.osusumeBuhinList
        .filter(
          (b: any) =>
            arrOsusumeId.indexOf(b.buhinOsusumeId) == -1 && b.id != null
        )
        .map((e: any) => {
          return { ...e, isDelete: 1 };
        });
      work.osusumeBuhinList = [...osusume, ...osusumeDelete];
      }
    } else {
      // 2022-01-31 morisako kobac-free add [START]
      let isDiscount = (work.isDiscount === 1);
      let filterBuhinList = buhinList.map((b: any) => {
        if (isDiscount) {
          return { ...b, buhinPriceZk: 0, buhinPriceZn: 0, kingakuZk: 0, kingakuZn: 0 };
        } else {
          return { ...b };
        }
      });
      // 2022-01-31 morisako kobac-free add [END]
      // 2022-01-31 morisako kobac-free mod [START]
      // work.buhinList = buhinList;
      work.buhinList = filterBuhinList;
      // 2022-01-31 morisako kobac-free mod [END]
    }

    /** 2021-07-09 sh #7273 it does not work, if deleted. [START] */
    /** 数量が0になったら削除フラグを立てて、削除する */
    // work.manualBuhinList = this.listManualBuhin;
    work.manualBuhinList = this.listManualBuhin.map((e: any) => {
      const isDelete = e.quantity > 0 ? 0 : 1;
      return { ...e, isDelete: isDelete }
    });
    /** listSelectedBuhinに手入力の部品が入ることはないので、ここは、オミットしておく */
    // if (work.manualBuhinList.length > 0 && this.listSelectedBuhin.length == 0) {
    //  work.manualBuhinList = work.manualBuhinList
    //    .filter((b: BuhinDetail) => b.id)
    //    .map((buhin: BuhinDetail) => {
    //      return { ...buhin, isDelete: 1 };
    //    });
    //}
    /** 2021-07-09 sh #7273 it does not work, if deleted. [END] */
    if (status == STATUS_SELECT_WORK_BUHIN.delete) {
      work.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    } else {
    work.buhinSelected = status;
    }

    if (this.editSeibi) {
      if (status == STATUS_SELECT_WORK_BUHIN.Initial || status == STATUS_SELECT_WORK_BUHIN.delete) {
        this.inspectService.changeWorkStatus(this.data);
      } else {
        this.data.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      }
    }
    this.removeEditMode();
    if (this.isDialog) {
      if (this.data.seibiList) {
        this.keepBuhinConfirm(this.data.seibiList);
        this.keepBuhinConfirm(this.data.manualSeibiList);
      } else {
          this.keepBuhinConfirmOsusume(this.data);
      }
    }

    let changeList: any = [];
    if (Object.keys(this.buhinChangeList).length > 0) {
      changeList = Object.values(this.buhinChangeList).filter(
        (b: any) => b.oldBuhinPrice != b.newBuhinPrice
      );
    }

    let doEmit = true;
    if (this.isBuhin) {
      const isDone = this.checkIsDone();
      if (isDone && this.checkBuhinChange(work)) {
        doEmit = false;
      }
    }
    if (this.isResetSeibi) {
      this.checkWorkBuhinSelected(work);
      const key = work.seibiDetailId || work.seibiId || work.seibiNm;
      this.$set(this.listBuhinConfirm, key, []);
    }

    if (doEmit) {
      this.workConfirm = util.deepCopy(work);

      //削除リストの確定化
      if (this.isDialog) {
        this.tmpDeletedManualBuhinList = util.deepCopy(this.tmpDeletedManualBuhinBuff);
      }

    //モーダルで動作しているときには
      if (this.data.seibiList) {
        let seibi: any;
        if (this.isManualWork) {
          seibi = this.data.manualSeibiList[this.activeWorkIndex];
        } else {
          seibi = this.data.seibiList[this.activeWorkIndex];
        }
        if (status == STATUS_SELECT_WORK_BUHIN.delete) {
          if (this.data.seibiList) {
            this.data.seibiList[this.activeWorkIndex].buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
            if (this.isManualWork) {
              this.data.manualSeibiList[this.activeWorkIndex].buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
            }
          } else {
            this.data.buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
          }
        }
        this.$emit("onconfirm", {
          inspectItem: this.data,
          seibi,
          notManual: !this.isManualWork,
          changeList
        });
      } else {
        if (status == STATUS_SELECT_WORK_BUHIN.delete) {
          if (this.data.seibiList) {
            this.data.seibiList[this.activeWorkIndex].buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
            if (this.isManualWork) {
              this.data.manualSeibiList[this.activeWorkIndex].buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
            }
          } else {
            this.data.buhinSelected = STATUS_SELECT_WORK_BUHIN.delete;
          }
        }
        this.$emit("onconfirm", { ...this.data, changeList });
      }
    }
    return doEmit;
  }

  addBuhinIsDelete(list: BuhinDetail[]) {
    return list.map(buhin => {
      return { ...buhin, isDelete: 0 };
    });
  }

  filterManualSeibi() {
    if (this.data.manualSeibiList && this.data.manualSeibiList.length > 0) {
      const listFiltered = this.data.manualSeibiList.filter(
        (seibi: Work) => seibi.buhinSelected > 0
      );
      if (listFiltered.length > 0) {
        this.data.manualSeibiList = util.deepCopy(listFiltered);
      }
    }
  }

  filterManualBuhin() {
    if (
      this.listManualBuhin.length > 0 &&
      this.buhinCategory[this.activeBuhinCateIndex] &&
      this.activeBuhinCateIndex >= 0
    ) {
      let buhinShubetsuId = -1;
      if (this.buhinCategory[this.activeBuhinCateIndex]) {
        buhinShubetsuId =
          this.buhinCategory[this.activeBuhinCateIndex].buhinShubetsuId || -1;
      } else if (this.activeBuhinCateIndex == -2) {
        buhinShubetsuId = 0;
      }
      const list = this.listManualBuhin.filter(
        buhin => buhinShubetsuId == buhin.buhinShubetsuId
      );
      /** 2022-07-25 sh #7995(BQR1016) add setTimeout. [START] */
      /** 手入力の部品が表示されないので、タイミングをずらしてみる。 */
      // this.$set(this, "listManualBuhinFiltered", list);
      setTimeout(() => {
        this.$set(this, "listManualBuhinFiltered", list);
      }, 300);
      /** 2022-07-25 sh #7995(BQR1016) add setTimeout. [END] */
    } else {
      // this.$set(this, "listManualBuhinFiltered", []);
    }
  }

  resetBuhin() {
    this.$set(this, "listSelectedBuhin", []);
    /** 2021-07-09 sh #7273 it does not work, if deleted. [START] */
    this.$set(this, "listManualBuhinFiltered", []);
    /** 2021-07-09 sh #7273 it does not work, if deleted. [END] */
    this.mapBuhin();
  }

  mapBuhin() {
    if (this.listBuhinData.length == 0) {
      return;
    }
    let selFilter: string[] = [];
    let promise = null;
    this.firstBuhinCd = null;
    if (this.listSelectedBuhin.length > 0) {
      let buhinContent: any = util.deepCopy(
        this.buhinCategory[this.activeBuhinCateIndex].items
      );
      this.filterOutBuhin(buhinContent);
      // 2022-01-31 morisako kobac-free add [START]
      buhinContent = buhinContent.map((element: any) => {
        let items = element.items.map((elm: any) => {
          let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
          if (b.length > 0) {
            return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
          } else {
            return { ...elm, isDiscount: 0 };
          }
        });
        return { ...element, items: items };
      });
      // 2022-01-31 morisako kobac-free add [END]
      this.$set(this, "buhinContent", buhinContent);
      promise = this.buhinContent.map((group, groupIndex) => {
        group.items.forEach((buhin: BuhinDetail, buhinIndex) => {
          buhin.buhinShubetsuId = this.activeBuhinShubetsuId;
          let findBuhin = this.listSelectedBuhin.find(
            (item: any) =>
              (item.buhinCd == buhin.buhinCd ||
                item.buhinOsusumeId == buhin.buhinOsusumeId) &&
              item.buhinNm == buhin.buhinNm &&
              item.isDelete != 1
          );

          if (findBuhin) {
            if (this.firstBuhinCd == null && findBuhin.buhinCd) {
              this.firstBuhinCd = findBuhin.buhinCd;
            }
            findBuhin.isExtreme = buhin.isExtreme;
            findBuhin.buhinShubetsuId = this.activeBuhinShubetsuId;
            let buhin1 = {
              ...findBuhin,
              quantityStep: buhin.quantityStep,
              defaultQuantity: buhin.defaultQuantity,
              buhinShubetsuId: this.activeBuhinShubetsuId,
              buhinPriceZk: findBuhin.buhinPriceZk || buhin.buhinPriceZk,
              buhinPriceZn: findBuhin.buhinPriceZn || buhin.buhinPriceZn
            };
            this.$set(
              this.buhinContent[groupIndex].items,
              buhinIndex,
              buhin1
            );
            if (selFilter.indexOf(group.buhinBunruiCd) == -1) {
              selFilter.push(group.buhinBunruiCd);
            }
          } else if (buhin.quantity > 0) {
            buhin.quantity = 0;
            this.$set(
              this.buhinContent[groupIndex].items,
              buhinIndex,
              buhin
            );
          }
        });
        return group;
      });
    } else {
      setTimeout(() => {
        const index = this.listBuhinData.length - 1;
        if (
          this.listBuhinData[index].items[this.activeBuhinCateIndex] &&
          this.listBuhinData[index].items[this.activeBuhinCateIndex].items
        ) {
          // let buhinContent = util.deepCopy(
          //   this.listBuhinData[index].items[this.activeBuhinCateIndex].items
          // );
          let buhinCategory = util.deepCopy(this.listBuhinData[index].items);
          this.$set(this, "buhinCategory", buhinCategory);
          let buhinContent: any = util.deepCopy(
            this.buhinCategory[this.activeBuhinCateIndex].items
          );
          // 2022-01-31 morisako kobac-free add [START]
          buhinContent = buhinContent.map((element: any) => {
            let items = element.items.map((elm: any) => {
              let b = this.freeOfChargeBuhinList.filter((e: any) => e.buhinCd.toString() === elm.buhinCd.toString());
              if (b.length > 0) {
                return { ...elm, kingakuZn: 0, kingakuZk: 0, buhinPriceZn: 0, buhinPriceZk: 0, isDiscount: 1 };
              } else {
                return { ...elm, isDiscount: 0 };
              }
            });
            return { ...element, items: items };
          });
          // 2022-01-31 morisako kobac-free add [END]
          const activeCateBuhins = util.deepCopy(buhinContent);
          this.$set(this, "activeCateBuhins", activeCateBuhins);
          this.filterOutBuhin(buhinContent);
          this.$set(this, "buhinContent", buhinContent);
          this.setFilterBuhin(selFilter);
          // this.$set(this, "selFilter", selFilter);
        }
      }, 10);
    }
    if (promise) {
      Promise.all(promise).then(value => {
        this.setFilterBuhin(selFilter);
        // this.$set(this, "selFilter", selFilter);
        // this.onFilter("");
      });
    }
  }

  scrollToBuhin(timeout = 100) {
    let buhinEle: any = null;
    let doScroll = false;
    if (this.firstBuhinCd) {
      buhinEle = document.querySelector(`[buhin-cd="${this.firstBuhinCd}"]`);
      doScroll = true;
    } else if (this.listManualBuhinFiltered.length > 0) {
      buhinEle = document.getElementById("topic-buhin-manual");
      doScroll = true;
    }
    setTimeout(() => {
      if (buhinEle) {
        buhinEle.scrollIntoView();
        this.nRetryScroll = 0;
      } else if (doScroll && this.nRetryScroll < 3) {
        this.nRetryScroll++;
        this.scrollToBuhin(300);
      }
    }, timeout);
  }

  setFilterBuhin(listSelFilter: any) {
    let selFilter: any = [];
    if (listSelFilter.length > 0) {
      selFilter = listSelFilter;
    } else if (this.activeBuhinCateIndex == this.defualtBuhinShubetsuIndex) {
      selFilter = [...this.defualtBuhinBunruiCdList];
    }
    this.$set(this, "selFilter", selFilter);
    this.onFilter("");
  }

  onClose() {
    this.showConfirmDialog2 = false;
    this.data.showWork = false;
    this.removeEditMode();
    this.filterManualSeibi();
    this.$emit("onclose", {
      isChange: this.isChange,
      isSocket: this.isSocket,
      isResetSeibi: this.isResetSeibi
    });
  }

  onBunhinClick(buhin: BuhinDetail, event: any) {
    if (this.disabledBtnNoBuhin) {
      event.preventDefault();
    } else {
      if (event.target.checked) {
        this.$set(buhin, "quantity", buhin.defaultQuantity || 1);
        if (this.data.sknInspectType == INSPECT_TYPE.RECOMMEND || this.data.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
          this.$set(buhin, "isSelected", true);
        }
        this.listSelectedBuhin.push(buhin);
      } else {
        this.$set(buhin, "quantity", 0);
        const index = this.findBuhinIndex(buhin);
        this.listSelectedBuhin.splice(index, 1);
      }
      this.checkDisabledBtnConfirm();
    }
  }

  onQuantityInput(buhin: BuhinDetail) {
    const itemIndex = this.findBuhinIndex(buhin);
    if (!buhin.quantity) {
      if (itemIndex > -1) {
        this.listSelectedBuhin.splice(itemIndex, 1);
      }
    } else if (itemIndex == -1) {
      this.listSelectedBuhin.push(buhin);
    } else {
      this.listSelectedBuhin[itemIndex].quantity = buhin.quantity;
    }
    this.checkDisabledBtnConfirm();
  }

  buhinChangePrice(buhin: BuhinDetail, isManual: boolean = false) {
    if (!isManual) {
      const itemIndex = this.findBuhinIndex(buhin);
      if (itemIndex > -1) {
        this.listSelectedBuhin[itemIndex].buhinPriceZn =
          buhin.buhinPriceZn || 0;
      }
    }
    if (!this.isDialog && buhin.id) {
      // MD-0015
      let buhinList: any;
      if (isManual) {
        buhinList = this.workBeforeChange.manualBuhinList;
      } else {
        buhinList = this.workBeforeChange.buhinList;
        if (this.workBeforeChange.osusumeBuhinList) {
          buhinList = [...buhinList, ...this.workBeforeChange.osusumeBuhinList];
        }
      }
      const oldBuhin = buhinList.find((b: BuhinDetail) => b.id == buhin.id);
      if (oldBuhin) {
        this.buhinChangeList[buhin.id] = {
          buhinNm: buhin.buhinNm,
          newBuhinPrice: buhin.buhinPriceZn,
          oldBuhinPrice: oldBuhin.buhinPriceZn
        };
      }
    }
  }

  onEditResult(event: any, work: any) {
    event.stopPropagation();
    this.$emit("onEditResult", work);
  }

  getExtremBuhinMaster() {
    return this.listBuhinActiveSebi.filter(
      buhin => buhin.buhinId == null && buhin.isExtreme == 1
    );
  }
  onSelectExtremeTab() {
    this.$set(this, "activeBuhinCateIndex", -2);
    this.$set(this, "activeCateBuhins", []);
    this.$set(this, "listManualBuhinFiltered", []);
    this.$set(this, "activeBuhinShubetsuId", 0);
    this.filterManualBuhin();
    if (this.listBuhinActiveSebi.length > 0) {
      const listExtMaster = this.getExtremBuhinMaster();
      if (listExtMaster.length > 0) {
        let buhinContent = [
          {
            buhinBunruiCd: "",
            buhinBunruiId: "",
            buhinBunruiNm: "",
            items: listExtMaster
          }
        ];
        this.$set(this, "buhinContent", buhinContent);
      } else {
        this.$set(this, "buhinContent", []);
      }
    } else {
      this.$set(this, "buhinContent", []);
    }
  }

  onSelectOsusumeTab() {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    // if (this.listManualBuhin.length <= 0) {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    this.$set(this, "activeBuhinCateIndex", -3);
    this.$set(this, "activeCateBuhins", []);
    if (this.osusumeBuhinList.length > 0) {
      const items = this.osusumeBuhinList.map((e: any) => {
        return { ...e, quantity: e.quantity || 0 };
      });
      let selectedBuhin = items.filter((e: any) => e.id && e.quantity > 0);
      let osusumeBuhins = items.filter((e: any) => e.quantity > 0);
      if (this.listSelectedBuhin.length == 0) {
      if (selectedBuhin && selectedBuhin.length > 0) {
        selectedBuhin.forEach((b: any) => {
          this.listSelectedBuhin.push(b);
        });
      } else if (osusumeBuhins && osusumeBuhins.length == 1) {
        items.forEach((e: any) => {
          if (e.quantity > 0) this.listSelectedBuhin.push(e);
        });
      }
      }
      let buhinContent = [
        {
          buhinBunruiCd: "",
          buhinBunruiId: "",
          buhinBunruiNm: "",
          items
        }
      ];
      this.$set(this, "buhinContent", buhinContent);
    } else {
        const listExtreme = this.getExtremBuhinMaster();
        if (listExtreme.length > 0) {
          this.onSelectExtremeTab();
        // 2023-08-00 BQR1048 add おすすめ整備の選択 [START]
        } else if (!this.isDialog && this.workBeforeChange.isExtreme) {
          this.onSelectExtremeTab();
        // 2023-08-00 BQR1048 add おすすめ整備の選択 [END]
        } else if (this.listSelectedBuhin.length > 0) {
          let buhinShubetsuCd = this.findBuhinShubetsuCd(
            this.listSelectedBuhin[0].buhinShubetsuId
          );
          this.selectBuhinShubetsu(buhinShubetsuCd, this.listSelectedBuhin);
        } else {
      this.$set(this, "buhinContent", []);
        }
    }
    this.$set(this, "listManualBuhinFiltered", []);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    /**
    this.$set(this, "listManualBuhin", []);
    } else {
      this.buhinCategory.forEach((cate, index) => {
        if (cate.buhinShubetsuId == this.listManualBuhin[0].buhinShubetsuId) this.activeBuhinCateIndex = index;
      });
      this.activeBuhinShubetsuId =
        this.buhinCategory[this.activeBuhinCateIndex].buhinShubetsuId || 0;
      let buhinContent = util.deepCopy(this.buhinCategory[this.activeBuhinCateIndex].items);
      const activeCateBuhins = util.deepCopy(buhinContent);
      this.$set(this, "activeCateBuhins", activeCateBuhins);
      this.$set(this, "buhinContent", buhinContent);
      this.filterManualBuhin();
      this.mapBuhin();
    }
    */
    this.filterManualBuhin();
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  }

  changeEditMode(e: any, work: any) {
    e.stopPropagation();
    if (!work.buhinNm || !this.disabledBtnNoBuhin) {
      if (work.editMode) {
        this.isChange = true;
        work.editMode = false;
        if (work.buhinNm && this.buhinChangeList[work.id]) {
          this.buhinChangeList[work.id].buhinNm = work.buhinNm;
        }
      } else {
        work.editMode = true;
      }
      this.$forceUpdate();
    }
  }

  removeEditMode() {
    // Remove edit mode from seibi
    if (this.data.manualSeibiList && this.data.manualSeibiList.length !== 0) {
      this.data.manualSeibiList.map((data: any) => delete data.editMode);
    }
    // Remove edit mode from buhin
    if (this.data.seibiList && this.data.seibiList.length !== 0) {
      this.data.seibiList.forEach((item: any) => {
        if (item.manualBuhinList && item.manualBuhinList.length !== 0) {
          item.manualBuhinList.map((e: any) => delete e.editMode);
        }
      });
    }
    if (this.data.manualSeibiList && this.data.manualSeibiList.length !== 0) {
      this.data.manualSeibiList.forEach((item: any) => {
        if (item.manualBuhinList && item.manualBuhinList.length !== 0) {
          item.manualBuhinList.map((e: any) => delete e.editMode);
        }
      });
    }
    // Remove edit mode from recommend page
    if (this.data.manualBuhinList && this.data.manualBuhinList.length !== 0) {
      this.data.manualBuhinList.map((data: any) => delete data.editMode);
    }
  }

  keepBuhinConfirm(seibiList: any) {
    if (seibiList) {
      const seibiListConfirm = seibiList.filter(
        (e: any) => e.buhinSelected != STATUS_SELECT_WORK_BUHIN.Initial
      );
      seibiListConfirm.forEach((seibi: any) => {
        const key = seibi.seibiDetailId || seibi.seibiId || seibi.seibiNm;
        if (key) {
        this.listBuhinConfirm[key] = seibi.buhinList
          .filter((b: any) => b.quantity > 0 && b.isDelete != 1)
          .map((b: BuhinDetail) => b.buhinCd);
        }
      });
    }
  }

  keepBuhinConfirmOsusume(seibi: any, isInit: boolean = false) {
    if (seibi) {
      let key: any = this.getOsusumeKey(seibi);
        if (key) {
        let buhinList = seibi.buhinList;
        if (isInit && (!seibi.isExtreme || seibi.isExtreme != 1)) {
          buhinList = buhinList.filter((b: any) => b.id);
        }
        if (seibi.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL && seibi.osusumeBuhinList) {
          const osusumeList = seibi.osusumeBuhinList.filter((b: any) => b.id);
          buhinList = [...buhinList, ...osusumeList];
        }

        this.listBuhinConfirm[key] = buhinList
          .filter((b: any) => b.quantity > 0 && b.isDelete != 1)
          .map((b: BuhinDetail) => b.buhinOsusumeId || b.buhinCd);
      }
    }
  }

  getOsusumeKey(seibi: any) {
    let key: any = "";
    if (seibi) {
      if (seibi.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
        if (seibi.osusumeId) {
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
        /** 2021-09-22 sh #7411 fix change key for osusume. [START] */
        // key = seibi.osusumeId;
        key = "osusume_" + seibi.osusumeId;
        /** 2021-09-22 sh #7411 fix change key for osusume. [END] */
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
        } else {
          key = "seibiId_" + seibi.seibiId;
        }
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
      } else {
        key = seibi.sknInspectSeibiDetailId;
      }
    }
    return key;
  }

  // buhinKey(buhin: BuhinDetail) {
  //   let key: any;
  //   if (this.activeSeibiId) {
  //     key = this.activeSeibiId;
  //   } else if (
  //     this.isManualWork &&
  //     this.data.manualSeibiList &&
  //     this.activeWorkIndex > -1
  //   ) {
  //     key = this.getOsusumeKey(this.data.manualSeibiList[this.activeWorkIndex]);
  //   } else if (
  //     this.data.seibiList &&
  //     this.data.seibiList.length > 0 &&
  //     this.activeWorkIndex > -1
  //   ) {
  //     key = this.getOsusumeKey(this.data.seibiList[this.activeWorkIndex]);
  //   } else {
  //     key = this.getOsusumeKey(this.data);
  //   }
  //   return key;
  // }

  isBuhinConfirm(buhin: BuhinDetail) {
    let key: any;
    if (this.activeSeibiId) {
      key = this.activeSeibiId;
    } else if (
      this.isManualWork &&
      this.data.manualSeibiList &&
      this.activeWorkIndex > -1
    ) {
      key =
        this.data.manualSeibiList[this.activeWorkIndex].seibiId ||
        this.data.manualSeibiList[this.activeWorkIndex].seibiNm;
    } else if (
      this.data.seibiList &&
      this.data.seibiList.length > 0 &&
      this.activeWorkIndex > -1
    ) {
      key = this.getOsusumeKey(this.data.seibiList[this.activeWorkIndex]);
    } else {
      key = this.getOsusumeKey(this.data);
    }
    if (key) {
      /** 2021-09-15 sh #7411 fix label after selecting buhin. [START] */
      // if (
      //   buhin.quantity > 0 &&
      //   this.listBuhinConfirm[key] &&
      //   (this.listBuhinConfirm[key].indexOf(buhin.buhinCd) > -1 ||
      //     this.listBuhinConfirm[key].indexOf(buhin.buhinOsusumeId) > -1)
      // ) {
      //   return true;
      // }
      if (buhin.quantity > 0 && key in this.listBuhinConfirm && buhin.buhinCd) {
        if (!this.listBuhinConfirm[key]) {
          this.$set(this.listBuhinConfirm, key, []);
        }
        if (this.listBuhinConfirm[key].length > 0 && this.listBuhinConfirm[key].find((e: any) => e ==buhin.buhinCd) ) {
          return true;
        }
      }
      if (buhin.quantity > 0 && key in this.listBuhinConfirm && buhin.buhinOsusumeId) {
        if (!this.listBuhinConfirm[key]) {
          this.$set(this.listBuhinConfirm, key, []);
        }
        if (this.listBuhinConfirm[key].find((e: any) => e == buhin.buhinOsusumeId)) {
          return true;
        }
      }
      /** 2021-09-15 sh #7411 fix label after selecting buhin. [END] */
    }
    return false;
  }

  onkeepBuhinMD15(data: any = null) {
    if (!this.isDialog) {
      if (data == null) {
        data = this.data;
      }
      /** 2021-09-22 sh #7411 fix init array. [START] */
      // this.listBuhinConfirm = {};
      Object.keys(this.listBuhinConfirm).forEach((item: any, key: any) => {
        this.$set(this.listBuhinConfirm, key, []);
      }, this);
      /** 2021-09-22 sh #7411 fix init array. [END] */
      if (Object.keys(data).length > 0) {
        if (data.seibiList) {
          this.keepBuhinConfirm(data.seibiList);
          this.keepBuhinConfirm(data.manualSeibiList);
        } else {
          this.keepBuhinConfirmOsusume(data);
        }
      }
    }
  }

  onConfirmDelete() {
    if (this.tmpResetWorkIndex > -1) {
      let work;
      if (this.data.seibiList) {
        work = this.data.seibiList[this.activeWorkIndex];
        if (this.isManualWork) {
          work = this.data.manualSeibiList[this.activeWorkIndex];
        }
      } else {
        work = this.data;
      }
      if (work.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
        this.resetRecommendWork();
      } else {
      this.resetWork();
      }
    } else if (this.tmpDeleteWorkIndex > -1) {
      const seibi: Work[] = this.data.manualSeibiList.splice(
        this.tmpDeleteWorkIndex,
        1
      );
      if (
        this.activeWorkIndex == this.tmpDeleteWorkIndex &&
        this.isManualWork
      ) {
        this.activeWorkIndex = -1;
      }
      this.inspectService.changeWorkStatus(this.data);
      if (seibi.length > 0 && seibi[0].seibiId != null) {
        const id: any = seibi[0].seibiId;
        this.reqService
          .deleteManualSeibi({
            sknUketsukeManualSeibiId: id,
            uketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(() => {
            this.$emit(
              "onCallbackDeleteManualSeibi",
              this.data.sknUketsukeInspectId
            );
          });
      }
      this.tmpDeleteWorkIndex = -1;
      this.$set(this, "listManualBuhinFiltered", []);
      this.$set(this, "listSelectedBuhin", []);
      this.mapBuhin();

      let isSeibiAllNobuhin = this.data.seibiList.every(
        (e: any) => e.buhinSelected == 0
      );
      if (
        this.data.seibiList.length == 0 &&
        this.data.manualSeibiList.length == 0
      ) {
        if (this.isDialog) {
          // not md-0015
          this.data.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
        }
        this.isChange = true;
        this.isSocket = true;
        this.$emit("callbackDeleteBuhin", {
          data: this.data
        });
      } else if (isSeibiAllNobuhin && this.data.manualSeibiList.length == 0) {
        this.data.workBuhinSelected = 0;
        this.isChange = true;
        this.isSocket = true;
        this.$emit("callbackDeleteBuhin", {
          data: this.data
        });
      }
    } else if (this.tmpDeletedBuhin != null) {
      const index = this.listManualBuhin.findIndex(
        e => e.buhinNm == this.tmpDeletedBuhin.buhinNm
      );
      this.listManualBuhin.splice(index, 1);
      this.filterManualBuhin();
      this.checkDisabledBtnConfirm();
      if (this.tmpDeletedBuhin.id) {
        this.reqService.deleteManualBuhin(this.tmpDeletedBuhin.id);
        
        //削除リストの退避
        if (this.isDialog) {
          this.tmpDeletedManualBuhinBuff.push(this.tmpDeletedBuhin.id);
        }

      }
      this.tmpDeletedBuhin = null;
      this.isChange = true;

      if (this.isDialog) {
      //if (this.activeWorkIndex > -1 && this.data.hasOwnProperty('manualSeibiList') && this.data.hasOwnProperty('seibiList')) {
        return;
      }
      let work: any;
      if (this.activeWorkIndex > -1) {
        if (this.isManualWork) {
          work = this.data.manualSeibiList[this.activeWorkIndex];
        } else {
          work = this.data.seibiList[this.activeWorkIndex];
        }
      } else {
        work = this.data;
      }
      work.manualBuhinList = this.listManualBuhin;
      this.checkWorkBuhinSelected(work);
      this.$emit("callbackDeleteBuhin", {
        data: this.data
      });
    }
  }

  getWork(data: any = null) {
    if (data == null) {
      data = this.data;
    }
    let work: any;
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    // if (this.isManualWork) {
    if (this.isManualWork && this.editSeibi) {
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
      work = data.manualSeibiList[this.activeWorkIndex];
      if (work == null) {
        if (this.activeSeibiNm) {
          const index = data.manualSeibiList.findIndex(
            (e: any) => e.seibiNm == this.activeSeibiNm
          );
          if (index > -1) {
            this.activeWorkIndex = index;
            work = data.manualSeibiList[this.activeWorkIndex];
          }
        }
      }
    } else if (data.seibiList && data.seibiList.length > 0) {
      work = data.seibiList[this.activeWorkIndex];
    } else {
      work = data;
    }
    return work;
  }

  isBuhinNotChange() {
    let work: any = this.getWork();
    let buhinList: any = [];
    if (work) {
      /** 2022-08-02 sh #8009(BQR1022) manual buhin for recommend. [START] */
      // buhinList = work.buhinList
      //   .filter((b: any) => b.isDelete != 1 && b.quantity > 0)
      //   .map((b: any) => +b.buhinCd)
      //   .sort();
      buhinList = work.buhinList
        .filter((b: any) => b.isDelete != 1 && b.quantity > 0)
        .map((b: any) => b.buhinCd ? +b.buhinCd: b.buhinNm)
        .sort();
      /** 2022-08-02 sh #8009(BQR1022) manual buhin for recommend. [END] */
      let manualBuhinList = work.manualBuhinList
        .filter((b: any) => b.isDelete != 1 && b.quantity > 0)
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
        // .map((b: any) => b.buhinNm)
        .map((b: any) => b.id ? b.id: b.buhinNm)
        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
        .sort();
      if (manualBuhinList && manualBuhinList.length > 0) {
        manualBuhinList.forEach((element: any) => {
          /** 2022-08-02 sh #8009(BQR1022) manual buhin for recommend. [START] */
          // buhinList.push(element);
          if (buhinList.findIndex(
            // (buhin: any) => buhin.buhinNm == element.buhinNm
            (buhin: any) => buhin == element // 2022-08-05 sh @fix bug.
          ) == -1) {
            buhinList.push(element);
          }
          /** 2022-08-02 sh #8009(BQR1022) manual buhin for recommend. [END] */
        });
      }
    }
    let buhinListStaging = this.listSelectedBuhin
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
      // .map((b: any) => (b.buhinOsusumeId ? +b.buhinOsusumeId : b.buhinCd ? +b.buhinCd: b.buhinNm))
      .map((b: any) => (b.buhinOsusumeId ? +b.buhinOsusumeId : b.buhinCd ? +b.buhinCd: b.id ? b.id: b.buhinNm))
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
      .sort();

    if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
      const osusumeBuhinList = work.osusumeBuhinList
        .filter((b: any) => b.isDelete != 1 && (b.isSelected || b.buhinId) && this.checkQuantity(b))
        .map((b: any) => +b.buhinOsusumeId);
      buhinList = [...buhinList, ...osusumeBuhinList].sort();
    }
    
    //削除確定済み内容を考慮
    if (this.isDialog && this.tmpDeletedManualBuhinList.length > 0) {
      buhinList = [...buhinList, ...this.tmpDeletedManualBuhinList].sort();
    }
    if (JSON.stringify(buhinList) == JSON.stringify(buhinListStaging)) {
      return true;
    }
    return false;
  }

  checkQuantity(osusumeBuhin: any) {
    let ret = true;
    let list = this.listSelectedBuhin
      .filter((b: any) => (b.buhinOsusumeId == osusumeBuhin.buhinOsusumeId || b.buhinCd == osusumeBuhin.buhinCd || b.buhinNm == osusumeBuhin.buhinNm) && b.quantity != osusumeBuhin.quantity)
      .map((b: any) => +b.buhinOsusumeId);
      if (list && list.length > 0) ret = false;
    return ret;
  }

  onCloseBuhinDialog() {
    if (
      this.activeWorkIndex !== -1 ||
      this.data.sknInspectType == INSPECT_TYPE.RECOMMEND ||
      this.data.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
    ) {
      if (this.isBuhinNotChange()) {
        if (this.isKouchinChange) {
          this.showConfirmDialog2 = true;
        } else {
        this.onClose();
        }
      } else {
        this.showConfirmDialog2 = true;
      }
    } else {
      this.onClose();
    }
  }

  isSelected(buhin: BuhinDetail) {
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [START] */
    if (buhin.isExtreme == 1) {
      return this.findBuhinIndex(buhin) > -1 && buhin.quantity > 0;
    }
    /** 2022-04-11 sh #7816(BQR956) Not selected if there are multiple. [END] */
    return this.findBuhinIndex(buhin) > -1;
  }

  hideBuhin() {
    this.$set(this, "showBuhin", false);
  }

  onClickManualBuhin(buhin: BuhinDetail) {
    if (!this.disabledBtnNoBuhin) {
      if (buhin.quantity == 0) {
        buhin.quantity = 1;
      } else {
        buhin.quantity = 0;
      }
      this.checkDisabledBtnConfirm();
    }
  }

  get katashikiShiteiNo() {
    if (this.carSelection.katashikiShiteiNo) {
      return this.carSelection.katashikiShiteiNo;
    }
    return "";
  }

  get ruibetsuKubunNo() {
    if (this.carSelection.ruibetsuKubunNo) {
      return this.carSelection.ruibetsuKubunNo;
    }
    return "";
  }

  get fTireSize() {
    // if (
    //   this.carSelection.fTireSizeWize &&
    //   this.carSelection.fTireSizeHenpei &&
    //   this.carSelection.fTireSizeInchi
    // ) {
    //   return `${this.carSelection.fTireSizeWize}/${
    //     this.carSelection.fTireSizeHenpei
    //   }/${this.carSelection.fTireSizeInchi}`;
    // }
    return this.carSelection.fTireSize;
  }
  get rTireSize() {
    // if (
    //   this.carSelection.rTireSizeWize &&
    //   this.carSelection.rTireSizeHenpei &&
    //   this.carSelection.rTireSizeInchi
    // ) {
    //   return `${this.carSelection.rTireSizeWize}/${
    //     this.carSelection.rTireSizeHenpei
    //   }/${this.carSelection.rTireSizeInchi}`;
    // }
    return this.carSelection.rTireSize;
  }

  initSeibiDisableSave(seibiList: any) {
    if (this.data.sknInspectType != null && this.data.sknInspectType <= 1) {
      seibiList.forEach((seibi: any) => {
        /** 2021-12-01 sh #7587 change check seibiIds. [START] */
        // if (this.isSeibiExist(seibi.seibiDetailId, this.data.sknInspectType)) {
        if (this.isSeibiDetailIdExist({seibiDetailId: seibi.seibiDetailId, sknUketsukeInspectId: this.data.sknUketsukeInspectId})) {
        /** 2021-12-01 sh #7587 change check seibiIds. [END] */
          seibi.disabledSave = true;
        /** 2021-09-22 sh #7411 add else. [START] */
        } else {
          seibi.disabledSave = false;
        /** 2021-09-22 sh #7411 add else. [END] */
        }
      });
    }
  }

  onClickInputBuhinNm(e: any) {
    e.stopPropagation();
  }

  filterOutBuhin(buhinContent: SubBuhinCategory[]) {
    let filterOut = "";
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 手入力の部品が表示されない場合があるので追加 add [START]
    setTimeout(() => {
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 手入力の部品が表示されない場合があるので追加 add [END]
    let work = this.getWork();
    if (work.seibiNm) {
      if (work.seibiNm.indexOf("左右") > -1) {
        filterOut = "";
      } else if (work.seibiNm.indexOf("左") > -1) {
        filterOut = "右";
      } else if (work.seibiNm.indexOf("右") > -1) {
        filterOut = "左";
      }
      if (filterOut) {
        buhinContent.forEach((cate: SubBuhinCategory) => {
          cate.items = cate.items.filter(
            (b: BuhinDetail) => b.buhinNm.indexOf(filterOut) == -1
            || b.buhinNm.indexOf("左右") > -1
          );
        });
      }
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 手入力の部品が表示されない場合があるので追加 add [START]
    }, 300);
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 手入力の部品が表示されない場合があるので追加 add [END]
  }

  onSelectAllBuhin() {
    // 2023-07-00 BQR1048 add おすすめ整備の選択 [START]
    let sknInspectType = 99;
    if (this.data.sknInspectType) {
      sknInspectType = this.data.sknInspectType;
    } else if (this.data.seibiList && this.data.seibiList.length > 0) {
      sknInspectType = this.data.seibiList[0].sknInspectType;
    }
    // 2023-07-00 BQR1048 add おすすめ整備の選択 [END]
    const work = this.getWork();
    if (work.osusumeBuhinList && work.osusumeBuhinList.length > 0) {
      this.buhinContent[0].items.forEach((e: any) => {
        this.$set(e, "quantity", 1);
        // 2023-07-00 BQR1048 mod おすすめ整備の選択 [START]
        // if (this.data.sknInspectType == INSPECT_TYPE.RECOMMEND || this.data.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
        if (sknInspectType == INSPECT_TYPE.RECOMMEND || sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
          // 2023-07-00 BQR1048 mod おすすめ整備の選択 [END]
          this.$set(e, "isSelected", true);
        }
      });
      // 2023-07-00 BQR1048 mod おすすめ整備の選択 [START]
      // if (this.data.sknInspectType == INSPECT_TYPE.RECOMMEND || this.data.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      if (sknInspectType == INSPECT_TYPE.RECOMMEND || sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      // 2023-07-00 BQR1048 mod おすすめ整備の選択 [END]
        this.osusumeBuhinList.forEach((o: any) => {
          this.$set(o, "isSelected", true);
        });
      }
      this.$set(this, "listSelectedBuhin", util.deepCopy(this.buhinContent[0].items));
      this.checkDisabledBtnConfirm(work);
    }
  }

  checkWorkBuhinSelected(work: any) {
    if (
      this.data.seibiList &&
      this.listManualBuhin.length == 0 &&
      this.listSelectedBuhin.length == 0
    ) {
      work.buhinSelected = 0;
      let isSeibiAllNobuhin = this.data.seibiList ? this.data.seibiList.every(
        (e: any) => e.buhinSelected == 0
      ): true;
      let isManualSeibiAllNobuhin = this.data.manualSeibiList ? this.data.manualSeibiList.every(
        (e: any) => e.buhinSelected == 0
      ): true;
      if (isSeibiAllNobuhin && isManualSeibiAllNobuhin) {
        this.data.workBuhinSelected = 0;
      }
    }
  }

  kouchinChange() {
    this.isChange = true;
    this.isKouchinChange = true;
  }

  /** 2021-09-24 sh #7428 improved initial selecting seibi. [START] */
  initialSelectSeibi() {
    if (!this.isManualWork && this.data && this.data.seibiList) {
      let indexList = [];
      for (let i=0; i < this.data.seibiList.length; i++) {
        if (this.data.seibiList[i].buhinSelected>0) {
          indexList.push(i);
          break;
        }
      }
      if (indexList.length>0) {
        this.onSelectWork(this.data.seibiList[indexList[0]], indexList[0], false);
      }
    }
  }
  /** 2021-09-24 sh #7428 improved initial selecting seibi. [END] */

  /** 2021-12-03 sh #7594 Because it is cached, call it directly. [START] */
  get shadaiNo() {
    if (this.currentState && this.currentState.customerCar) {
      return this.currentState.customerCar.shadaiNo;
    }
    return "";
  }
  /** 2021-12-03 sh #7594 Because it is cached, call it directly. [END] */
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        if (res.freeOfChargeNm.length > 2) {
          this.freeOfChargeNm = res.freeOfChargeNm.substr(0, 2);
        } else {
          this.freeOfChargeNm = res.freeOfChargeNm;
        }
      } else {
        this.freeOfChargeNm = '無償';
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
  setInspectDescription(work: any): any {
    let manualSeibiList = [];
    const manualSeibi = {
      seibiId: work.seibiId
      , seibiDetailId: work.seibiDetailId
      , seibiNm: work.seibiNm
      , buhinSelected: work.buhinSelected
      , kousuu: work.kousuu
      , buhinList: work.buhinList
      , manualBuhinList: work.manualBuhinList
      , sknRecommendInspectCategoryId: work.sknRecommendInspectCategoryId
    }
    manualSeibiList.push(manualSeibi);
    const inspectDescription = {
      id: this.data.id
      , sknUketsukeInspectId: this.data.sknUketsukeInspectId
      , sknInspectDescriptionId: this.data.sknInspectDescriptionId
      , sknInspectDescriptionNm: this.data.sknInspectDescriptionNm
      , sknUketsukeExtendsId: this.data.sknUketsukeExtendsId
      , sknInspectCommentId: this.data.sknInspectCommentId
      , sknInspectType: this.data.sknInspectType
      , branchId: this.data.branchId
      , inspectResult: this.data.inspectResult
      , inspectValue: this.data.inspectValue
      , inspectValueStr: this.data.inspectValueStr
      , buhinDanaJisha: this.data.buhinDanaJisha
      , buhinDanaItaku: this.data.buhinDanaItaku
      , isGaichu: this.data.isGaichu
      , isNumber: this.data.isNumber
      , inspectValueList: this.data.inspectValueList
      , inspectValueViewType: this.data.inspectValueViewType
      , workBuhinSelected: this.data.workBuhinSelected
      , inspectCd: this.data.inspectCd
      , isHoanKijun: this.data.isHoanKijun
      , manualSeibiList: manualSeibiList
      , sknInspectSubCategoryId: this.data.sknInspectSubCategoryId
      , displayOrder: this.data.displayOrder
      , subDisplayOrder: this.data.subDisplayOrder
      , isDiscount: this.data.isDiscount
      , updatePgid: this.data.updatePgid
      , doTenken: this.data.doTenken
      , dataStateKbn: this.data.dataStateKbn
      , sknInspectSeibiFeeId: this.data.sknInspectSeibiFeeId
    }
    return inspectDescription;
  }
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]

  chkRedundancyTopic(target:any , i:number){
    console.log("aa",(i+1) +"-"+ this.buhinContent.length);
    //条件:手入力に隣接したカテゴリ
    if( i + 1 == this.buhinContent.length ){
      //条件：カテゴリ名が手入力
      console.log("bb",target.buhinBunruiNm +"-"+ this.listManualBuhinName);
      if( target.buhinBunruiNm == this.listManualBuhinName ){
        //条件：カテゴリ内が0件で実際に2回表示になる
        console.log("cc",target.items.length +"-"+ this.listManualBuhinFiltered.length);
        if( target.items && target.items.length == 0 && this.listManualBuhinFiltered.length > 0 ){
          return false;
        }
      }
    }
    return true;

  }
}
